import { UnknownAction, ThunkDispatch, configureStore, createDynamicMiddleware } from "@reduxjs/toolkit";

import { listenerMiddleware } from "@/store/middleware/listenerMiddleware";
import { api } from "@/services/api";
import { combineReducers } from "@reduxjs/toolkit";
import userslice from "@/reducer/userslice";
import tagslice from "@/reducer/tagslice";
import negtagslice from "@/reducer/negTagSlice";
import { rememberReducer, rememberEnhancer } from "redux-remember";
import designSlice from "@/reducer/designslice";
import modeslice from "@/reducer/modeslice";
import canvasSlice from "@/reducer/canvasSlice";
import contentSlice from "@/reducer/contentSlice";
import socketMiddleware from "./middleware/middleware";
import chatSlice from "@/reducer/chatSlice";
import mymodelSlice from "@/reducer/mymodelSlice";

const allReducers = {
  users: userslice,
  tags: tagslice,
  negtags: negtagslice,
  mode: modeslice,
  design: designSlice,
  canvas: canvasSlice,
  contents: contentSlice,
  chat: chatSlice,
  mymodel: mymodelSlice,
  [api.reducerPath]: api.reducer,
};
const rootReducer = combineReducers(allReducers);
const rememberedRootReducer = rememberReducer(rootReducer);
const rememberedKeys: (keyof typeof allReducers)[] = ["users", "tags", "negtags", "mode", "mymodel"];

export const store = configureStore({
  reducer: rememberedRootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(api.middleware).concat(socketMiddleware).prepend(listenerMiddleware.middleware);
  },
  enhancers: (getDefaultEnhancers) => {
    return getDefaultEnhancers().concat(
      rememberEnhancer(
        window.localStorage, // or window.sessionStorage, or your own custom storage driver
        rememberedKeys,
        {
          persistDebounce: 300,
          prefix: "@@aldai-",
        }
      )
    );
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export type AppThunkDispatch = ThunkDispatch<RootState, any, UnknownAction>;
